angular.module("app").directive("colorFlowerFamilyPieChart", function () {
  function link(scope) {
    scope.$watch("selectedItem", bindData);

    function bindData() {
      document.getElementById("my_color_flower_family_dataviz").innerHTML = "";

      const width = 500;
      const height = 400;
      const margin = 20;

      scope.selectedColor = {
        hex: '#43f234',
        title: 'COLOR'
      };

      // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
      const radius = Math.min(width, height) / 2 - margin;

      const svg = d3
        .select("#my_color_flower_family_dataviz")
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

      // Create dummy data
      const data = {
        "red": 30,
        "orange": 30,
        "yellow": 30,
        "green": 30,
        "blue": 30,
        "purple": 30,
        "pink": 30,
        "brown": 30,
        "white": 30
      };

      const colorData = {
        "red": { hex: "#e6341c" },
        "orange": { hex: "#f2891d" },
        "yellow": { hex: "#fae51b", },
        "green": { hex: "#46ac33" },
        "blue": { hex: "#37b1e6" },
        "purple": { hex: "#6d4595" },
        "pink": { hex: "#f7c6de" },
        "brown": { hex: "#63310e" },
        "white": { hex: "#ffffff" },
      };

      // Compute the position of each group on the pie:
      const pie = d3.layout
        .pie()
        .sort(null) // Do not sort group by size
        .value(function (d) {
          return d.value;
        });
      const data_ready = pie(d3.entries(data));

      // The arc generator
      const arc = d3.svg
        .arc()
        .innerRadius(radius * 0.7) // This is the size of the donut hole
        .outerRadius(radius * 0.8);

      const arc2 = d3.svg
        .arc()
        .innerRadius(radius * 0.7)
        .outerRadius(radius * 0.9);

      // Another arc that won't be drawn. Just for labels positioning
      const outerArc = d3.svg
        .arc()
        .innerRadius(radius * 0.9)
        .outerRadius(radius * 0.9);

      // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
      svg
        .selectAll("allSlices")
        .data(data_ready)
        .enter()
        .append("path")
        .attr("d", arc)
        .attr("transform", function (d) {
          if (d.data.key === scope.selectedItem.title) {
            const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
            const offsetY = -radius * 0.1 * Math.cos(midangle);
            const offsetX = radius * 0.1 * Math.sin(midangle);
            return `translate(${offsetX}, ${offsetY})`;
          }

          return "translate(0,0)";
        })
        .attr("fill", function (d) {
          return colorData[d.data.key].hex;
        })
        .attr(
          "stroke", function (d) {
            return colorData[d.data.key].hex === "#ffffff"
              ? "#E0E0DD"
              : colorData[d.data.key].hex;
          }
        )
        .style(
          "stroke-width",  function (d) {
            return colorData[d.data.key].hex === "#ffffff"
              ? "1px"
              : "0px"
          }
        );

      // Add the polylines between chart and labels:
      svg
        .selectAll("allPolylines")
        .data(data_ready)
        .enter()
        .append("polyline")
        .attr("stroke", "black")
        .style("fill", "none")
        .attr("stroke-width", 1)
        .attr("points", function (d) {
          const posA = arc2.centroid(d); // line insertion in the slice
          const posB = outerArc.centroid(d); // line break: we use the other arc generator that has been built only for that
          const posC = outerArc.centroid(d); // Label position = almost the same as posB
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2; // we need the angle to see if the X position will be at the extreme right or extreme left
          posC[0] = radius * 1 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left

          if (d.data.key === scope.selectedItem.title) {
            const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
            posA[1] += -radius * 0.1 * Math.cos(midangle);
            posA[0] += radius * 0.1 * Math.sin(midangle);
          }

          return [posA, posB, posC];
        });

      svg
        .selectAll("allLabels")
        .data(data_ready)
        .enter()
        .append("text")
        .text((d) => `${d.data.value}%`)
        .attr("transform", function (d) {
          const pos = outerArc.centroid(d);
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
          pos[0] = radius * 1.05 * (midangle < Math.PI ? 1 : -1);
          pos[1] += 8;
          return "translate(" + pos + ")";
        })
        .attr("font-size", "18px")
        .attr("font-weight", "300")
        .attr("style", "font-family: Gotham SSm A, Gotham SSm B")
        .style("text-anchor", function (d) {
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
          return midangle < Math.PI ? "start" : "end";
        });

      if (scope.mode === 'flowerFamily') {
        svg
          .append("text")
          .text("35")
          .attr("transform", "translate(0, -20)")
          .attr("font-size", "40px")
          .attr("text-anchor", "middle")
          .attr("style", "font-family: Gotham SSm A, Gotham SSm B");

        svg
          .append("text")
          .text("FLOWER FAMILIES")
          .attr("transform", "translate(0, 15)")
          .attr("font-size", "22px")
          .attr("text-anchor", "middle")
          .attr("style", "font-family: Gotham SSm A, Gotham SSm B");

        svg
          .append("text")
          .text(`ARE ${scope.selectedItem.title}`)
          .attr("transform", "translate(0, 40)")
          .attr({
            "text-anchor": "middle",
            "font-size": "22px",
          })
          .attr("style", "font-family: Gotham SSm A, Gotham SSm B; text-transform: uppercase;");
      }
      else {
      svg
        .append("text")
        .text("12")
        .attr("transform", "translate(0, -55)")
        .attr("font-size", "40px")
        .attr("text-anchor", "middle")
        .attr("style", "font-family: Gotham SSm A, Gotham SSm B");

      svg
        .append("text")
        .text("STATES HAVE")
        .attr("transform", "translate(0, -10)")
        .attr("font-size", "22px")
        .attr("text-anchor", "middle")
        .attr("style", "font-family: Gotham SSm A, Gotham SSm B");

      svg
        .append("text")
        .text(`${scope.selectedItem.title}`)
        .attr("transform", "translate(0, 15)")
        .attr({
          "text-anchor": "middle",
          "font-size": "22px",
          "text-transform": "uppercase",
        })
        .attr("style", "font-family: Gotham SSm A, Gotham SSm B; text-transform: uppercase;");

      svg
        .append("text")
        .text("FLOWER")
        .attr("transform", "translate(0, 40)")
        .attr({
          "text-anchor": "middle",
          "font-size": "22px",
          "text-transform": "uppercase",
        })
        .attr("style", "font-family: Gotham SSm A, Gotham SSm B");

      svg
        .append("text")
        .text("FAMILIES")
        .attr("transform", "translate(0, 65)")
        .attr({
          "text-anchor": "middle",
          "font-size": "22px",
          "text-transform": "uppercase",
        })
        .attr("style", "font-family: Gotham SSm A, Gotham SSm B");
      }
    }
  }
  return {
    restrict: "E",
    templateUrl: "app/directives/dbColorFlowerFamilyPieChart/dbColorFlowerFamilyPieChartView.html",
    link: link,
    scope: {
      selectedItem: "=",
      mode: "=",
    },
  };
});
